import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AdditionaInfoMessageType } from '../../enums/messages';
import { DialogTitles } from '../../enums/dialog-titles';

@Component({
    selector: 'app-alter-details-dialog',
    templateUrl: './alter-details-dialog.component.html',
    styleUrl: './alter-details-dialog.component.scss',
    standalone: false
})
export class AlterDetailsDialogComponent {
  detailsForm!: FormGroup;
  dialogTitles: typeof DialogTitles = DialogTitles;
  errorMessages: typeof AdditionaInfoMessageType = AdditionaInfoMessageType;
  constructor(private dialogRef: MatDialogRef<AlterDetailsDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.detailsForm = new FormGroup({
      contactNumber: new FormControl(this.data.contactNumber, [Validators.required,Validators.pattern(/^(0[0-9]{9}|\+27[0-9]{9})$/)]),
      address: new FormControl(this.data.address, [Validators.required]),
      suburb: new FormControl(this.data.suburb, [Validators.required]),
      city: new FormControl(this.data.city, [Validators.required]),
      code: new FormControl(this.data.code, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
    });
  } 


  onClose(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    this.dialogRef.close(this.detailsForm);
  }
}
